<template>
    <div class="allotment-data-container">
        <select-type-school-level-toolbar
            :listType="listType"
            :listSchoolLevel="listSchoolLevel"
            :filterForm="filterForm"/>

        <div class="d-flex align-center justify-space-between">
          <filter-form
              :listType="listType"
              :contactStatusList="contactStatusList"
              :listSchoolLevel="listSchoolLevel"
              :filterForm="filterForm" />
          <div>
                <button
                    v-if="checkAuthorization('allotment-contact_create')"
                    class="create-allotment-btn"
                    @click="showModalCreate"
                >
                    THÊM LỘ TRÌNH
                    <v-icon>mdi-plus</v-icon>
                </button>
            </div>
        </div>


        <div
            v-if="allotmentList.length === 0"
            class="no-result text-center mt-2">
          <span>Chưa có lộ trình nào</span>
        </div>

        <v-row v-else>
            <v-col cols="6" class="px-11" v-for="(allotment, index) in allotmentList" :key="index">
                <div class="allotment-wrapper">
                    <div class="allotment-header">
                        <span class="allotment-name">
                            {{ allotment.name }}
                        </span>
                        <div class="allotment-actions">
                            <span
                                v-if="checkAuthorization('allotment-contact_update')"
                                class="allotment-action"
                                @click="showModalDetail(allotment)"
                            >
                                Sửa
                            </span> |
                            <span
                                v-if="checkAuthorization('allotment-contact_delete')"
                                class="allotment-action"
                                @click="deleteAllotment(allotment)"
                            >
                                Xóa
                            </span>
                        </div>
                    </div>
                    <div class="allotment-sources">
                        <div class="d-flex">
                          <v-col cols="6">
                            <div class="mb-4">
                              <div class="allotment-data">
                                <v-icon style="transform: rotate(270deg);">mdi-merge</v-icon>
                                <div class="allotment-name">
                                  Nguồn phân bổ
                                </div>
                              </div>
                              <div class="d-flex flex-wrap">
                              <span
                                  class="content-item mb-2"
                                  v-for="source in allotment.sources">
                                {{ source.name }}
                              </span>
                              </div>
                              <div class="show-all-index"
                                   @click="showIndex(allotment)">
                                Xem chỉ số
                              </div>
                            </div>

                            <div>
                              <div class="allotment-data">
                                <v-icon>mdi-storefront</v-icon>
                                <div class="allotment-name">
                                  Kho
                                </div>
                              </div>
                              <span class="content-item">
                                Kho {{ allotment.store }}
                              </span>
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div class="allotment-data">
                              <v-icon>mdi-gift</v-icon>
                              <div class="allotment-name">
                                Nhóm sản phẩm
                              </div>
                            </div>

                            <div class="wrapper-content-product">
                              <div v-for="productG in allotment.productGroupsName" class="mt-2">
                                {{ productG.name }}
                              </div>
                            </div>

                          </v-col>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>

        <modal-view-allocation-index
            :showModalIndex="showModalIndex"
            :allotment="allotment"
        />

        <allotment-form
            v-if="showCreate"
            :showCreate="showCreate"
            :isCreate="isCreate"
            :storeStocks="storeStocks"
            :listSchoolLevel="listSchoolLevel"
            :listType="listType"
            :allotment="allotment"
            :productGroups="productGroups"
            :contactStatusList="contactStatusList"
            :loading="loading"
            :listRankForSelect="listRankForSelect"
        />
    </div>
</template>

<script>
import ModalViewAllocationIndex from './ModalViewAllocationIndex'
import AllotmentForm from './AllotmentForm'
import FilterForm from './FilterForm'
import SelectTypeSchoolLevelToolbar from './SelectTypeSchoolLevelToolbar'

import RepositoryFactory from '@/repositories/RepositoryFactory'
const AllotmentRepository = RepositoryFactory.get('allotment')
const SchoolLevelRepository = RepositoryFactory.get('school_level')
export default {
    components: {
      ModalViewAllocationIndex,
      AllotmentForm,
      FilterForm,
      SelectTypeSchoolLevelToolbar
    },
    props: {
      allotmentList: {
        type: Array,
        default: () => {[]}
      },
      filterForm: {
        type: Object,
        default: () => {}
      },
      contactStatusList: {
        type: Array,
        default: () => {[]}
      },
      productGroups: {
        type: Array,
        default: () => {[]}
      },
      listType: {
        type: Array,
        default: () => []
      },
      listSchoolLevel: {
        type: Array,
        default: () => []
      },
      listRankForSelect: {
        type: Array,
        default: () => {[]}
      }
    },
    data() {
        return {
          showCreate: false,
          isCreate: true,
          showModalIndex: false,
          allowCreateAllotment: true,
          allotment: {
            name: '',
            showEdit: {
              total_m: false,
              total_a: false,
              total_e: false,
            },
            sourcesIds: [],
            productGroups: [],
            total_m: 0,
            total_a: 0,
            total_e: 0,
            sources: []
          },
          storeStocks: [
            { value: 'T', name: 'Kho T' },
            { value: 'C', name: 'Kho C' },
            { value: 'M', name: 'Kho M' },
          ],
          loading: false
        }
    },

    created() {
      Bus.$on('show-detail-allotment-modal', allotment => {
          this.showModalDetail(allotment)
      })

      Bus.$on('close-allotment-index-modal', () => {
        this.showModalIndex = false
      })
      
      Bus.$on('save-allotment', allotment => {
        this.saveAllotment(allotment)
      })

      Bus.$on('close-create-allotment-modal', () => {
          this.showCreate = false
      })
    },

    beforeDestroy() {
      Bus.$off('show-detail-allotment-modal')
      Bus.$off('save-allotment')
      Bus.$off('close-allotment-index-modal')
      Bus.$off('close-create-allotment-modal')
    },
    
    methods: {
        showIndex(allotment) {
            this.allotment = allotment
            this.showModalIndex = true
        },

        showModalCreate() {
          this.allotment = {
            name: '',
            showEdit: {
              total_m: true,
              total_a: true,
              total_e: true,
            },
            sourcesIds: [],
            productGroups: [],
            total_m: '',
            total_a: '',
            total_e: '',
            sources: [],
            schoolLevelId: this.filterForm.schoolLevelId,
            typeId: this.filterForm.typeId
          }
          this.isCreate = true
          this.showCreate = true
        },

        showModalDetail(allotment) {
          this.allotment = _.cloneDeep(allotment)
          this.isCreate = false
          this.showCreate = true
        },

        async saveAllotment(data) {
          // const loader = this.$loading.show()
          this.appLoadingData(true)
          this.loading = true

          let sourcesData = data.sources.map(source => {
            return {
              statusId: source.statusId,
              numberOfContactA: +source.numberOfContactA,
              numberOfContactM: +source.numberOfContactM,
              numberOfContactE: +source.numberOfContactE,
            }
          })

          const dataCreated = {
            name: data.name,
            store: data.store,
            schoolLevelId: data.schoolLevelId,
            typeId: data.typeId,
            productGroups: data.productGroups.filter(proG => proG !== 0),
            sources: sourcesData,
            rankIds: data.rankIds && _.isArray(data.rankIds) ? data.rankIds : []
          }

            if (this.isCreate) {
              let res = await AllotmentRepository.create(dataCreated)
              // loader.hide()
              this.appLoadingData(false)
              this.loading = false
              if (res.success) {
                this.showCreate = false
                this.allowCreateAllotment = true
                this.$swal({
                    title: 'Cập nhật dữ liệu thành công',
                    timer: 1000
                })
                Bus.$emit('search-allotment-list', this.filterForm)
              } else {
                this.allowCreateAllotment = true
                this.$swal({
                    title: 'Lỗi!',
                    text: _.get(res, 'message', '')
                })
              }
            } else {
              let res = await AllotmentRepository.update(data.id, dataCreated)
              // loader.hide()
                this.appLoadingData(false)
              this.loading = false
              if (res.success) {
                this.showCreate = false
                this.allowCreateAllotment = true
                this.$swal({
                  title: 'Cập nhật dữ liệu thành công',
                  timer: 1000
                })
                Bus.$emit('search-allotment-list', this.filterForm)
              } else {
                this.allowCreateAllotment = true
                this.$swal({
                  title: 'Lỗi!',
                  text: _.get(res, 'message', '')
                })
              }
            }
        },

        async deleteAllotment(allotment) {
          this.$swal({
            title: 'Bạn có chắc muốn xóa Lộ trình này?',
            showCancelButton: true,
            cancelButtonText: 'Bỏ qua'
          }).then(async response => {
            if (response.value) {
              // const loader = this.$loading.show();
              this.appLoadingData(true)
              const res = await AllotmentRepository.delete(allotment.id)
              // loader.hide();
              this.appLoadingData(false)
              if (res.success) {
                this.$swal({
                  title: 'Cập nhật dữ liệu thành công',
                  timer: 1000
                })
                Bus.$emit('search-allotment-list', this.filterForm)
              } else {
                this.$swal({
                    title: 'Lỗi!',
                    text: _.get(res, 'message', '')
                })
              }
            }
          })
        },
    }
}
</script>

<style scoped>
.allotment-data-container {
    padding-top: 10px;
}

.create-allotment-btn {
    padding: 5px 8px;
    border: 1px solid black;
    font-size: 16px;
    font-weight: 400;
    border-radius: 8px;
}

.allotment-wrapper {
    background-color: white;
    border: 1px inner black;
    border-radius: 15px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    height: 100%;
}

.allotment-header {
    width: 100%;
    padding: 15px 20px 15px 30px;
    background-color: #F3F2F9;
    border-radius: 15px 15px 0px 0px;
}

.allotment-name {
    font-size: 20px;
    font-weight: 600;
}

.allotment-actions {
    display: none;
    font-size: 14px;
    color: #2D9CDB;
    float: right;
    padding-top: 4px;
}

.allotment-action {
    cursor: pointer;
}

.allotment-action:hover {
    text-decoration: underline;
    text-underline-position: below;
}

.allotment-wrapper:hover .allotment-actions {
    display: block;
}

.allotment-sources {
    padding: 15px 20px 15px 30px;
}

.allotment-data {
    display: flex;
    padding: 10px 0px;
}

.allotment-data i {
    font-size: 24px;
}

.allotment-name {
    font-size: 16px;
    padding: 4px 0px 0px 10px;
}

.allotment-data:hover .allotment-name {
    font-weight: 600;
}

.allotment-data.no-data {
    color: red;
}

.role-actions {
    display: none;
    font-size: 14px;
    color: #2D9CDB;
    padding: 6px 0px 0px 10px;
}

.role-action {
    cursor: pointer;
}

.role-action:hover {
    text-decoration: underline;
    text-underline-position: below;
}

.allotment-data:hover .role-actions {
    display: block;
}

.show-all-index {
    font-style: italic;
    cursor: pointer;
}

.show-all-index:hover {
    text-decoration: underline;
    text-underline-position: below;
}
.content-item {
  padding: 4px 20px;
  margin-right: 10px;
  border: 1px solid #D0D0D0;
  box-sizing: border-box;
  border-radius: 7px;
}
.wrapper-content-product {
  margin-left: 12px;
  border-left: 1px dotted;
  padding-left: 22px;
}
</style>
